@let alertData = alertService.alert$ | async;
@if (alertData && alertData.options) {
    @let alert = alertData.options;
    <div
        *transloco="let t"
        class="bazis-alert"
        [class]="alert.cssClass"
    >
        <div class="bazis-alert__wrapper">
            @if (alert.icon) {
                <div class="bazis-alert__icon">
                    <bazis-sign-status [color]="alert.color">
                        <bazis-icon
                            slot="icon"
                            [name]="alert.icon"
                        ></bazis-icon>
                    </bazis-sign-status>
                </div>
            }

            <div
                class="bazis-alert__content"
                part="content"
            >
                @if (alert.headerKey) {
                    <div class="bazis-alert__title">
                        {{ t(alert.headerKey, alert.headerParams) }}
                    </div>
                }

                @if (alert.header) {
                    <div class="bazis-alert__title">
                        {{ alert.header }}
                    </div>
                }

                @if (alert.message) {
                    <div
                        class="bazis-alert__message"
                        [innerHTML]="alert.message"
                    ></div>
                }

                @if (alert.messageKey) {
                    <div
                        class="bazis-alert__message"
                        [innerHTML]="t(alert.messageKey, alert.messageParams)"
                    ></div>
                }

                <div class="bazis-alert__buttons">
                    @for (button of alert.buttons; track $index) {
                        <bazis-button
                            [fill]="button.fillButton || 'solid'"
                            [color]="button.color || 'action'"
                            [size]="button.size || 'regular'"
                            (click)="buttonClick(button)"
                        >
                            @if (button.iconStart) {
                                <bazis-icon
                                    slot="start"
                                    [icon]="button.iconStart"
                                ></bazis-icon>
                            }
                            @if (button.iconEnd) {
                                <bazis-icon
                                    slot="end"
                                    [icon]="button.iconEnd"
                                ></bazis-icon>
                            }
                            {{ t(button.titleKey, button.titleParams) }}
                        </bazis-button>
                    }
                </div>
            </div>

            @if (alert.hasCloseIcon) {
                <button
                    class="bazis-alert__close"
                    (click)="dismiss()"
                >
                    <bazis-icon
                        [icon]="alert.closeIcon"
                        size="compact"
                    ></bazis-icon>
                </button>
            }
        </div>
    </div>
    <div
        class="bazis-backdrop"
        (click)="dismiss()"
    ></div>
}
